import { render } from "./FlowDescriptionModal.vue?vue&type=template&id=48e9b97e"
import script from "./FlowDescriptionModal.vue?vue&type=script&lang=js"
export * from "./FlowDescriptionModal.vue?vue&type=script&lang=js"

import "./FlowDescriptionModal.vue?vue&type=style&index=0&id=48e9b97e&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__